

import { configureStore } from '@reduxjs/toolkit'
import profile from './profile'
import subscription from "./subscription";

export default configureStore({
    reducer: {
        profile: profile,
        subscription: subscription
    },
})